"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var ParBrandsBannersListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsBannersListCtl, _super);
    function ParBrandsBannersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_banner_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.banner_url; });
        _this.dk_geometry_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.geometry_type_title; });
        _this.dk_geometry_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.geometry_type_code; });
        _this.dk_image_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.image_type_title; });
        _this.dk_image_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.image_type_code; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_width = UIUtils_1.UIUtils.IProp2Str(function (o) { o.width; });
        _this.dk_height = UIUtils_1.UIUtils.IProp2Str(function (o) { o.height; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_is_all_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_country; });
        _this.dk_countries_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.countries_count; });
        _this.dk_order_number = UIUtils_1.UIUtils.IProp2Str(function (o) { o.order_number; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsBannersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            cdn_baseurl: "",
            dimensionsFilter: [],
            geometryFilter: [],
            typesFilter: []
        };
    };
    ParBrandsBannersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand banner with id [" + id + "] not found !";
    };
    ParBrandsBannersListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListBrandBannersByBrandsGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            _this.DATA.dimensionsFilter = [];
            var dimension_filter_map = new Map();
            _this.DATA.geometryFilter = [];
            var geometry_filter_map = new Map();
            _this.DATA.typesFilter = [];
            var types_filter_map = new Map();
            for (var i = 0; i < resp.list.length; i++) {
                var dKey = resp.list[i].width + "/" + resp.list[i].height + " px";
                if (!dimension_filter_map.get(dKey)) {
                    _this.DATA.dimensionsFilter.push({ text: dKey, value: dKey });
                    dimension_filter_map.set(dKey, dKey);
                }
                var gKey = "" + resp.list[i].geometry_type_title;
                if (!geometry_filter_map.get(gKey)) {
                    _this.DATA.geometryFilter.push({ text: gKey, value: gKey });
                    geometry_filter_map.set(gKey, gKey);
                }
                var tKey = "" + resp.list[i].image_type_title;
                if (!types_filter_map.get(tKey)) {
                    _this.DATA.typesFilter.push({ text: tKey, value: tKey });
                    types_filter_map.set(tKey, tKey);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    banner_url: resp.list[i].banner_url,
                    geometry_type_code: resp.list[i].geometry_type_code,
                    geometry_type_title: resp.list[i].geometry_type_title,
                    image_type_code: resp.list[i].image_type_code,
                    image_type_title: resp.list[i].image_type_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    width: resp.list[i].width,
                    height: resp.list[i].height,
                    is_deprecated: resp.list[i].is_deprecated,
                    is_all_country: resp.list[i].is_all_country,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    countries_count: resp.list[i].countries_count,
                    order_number: resp.list[i].order_number
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBannersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandBanner.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                banner_url: data.banner_url,
                geometry_type_code: data.geometry_type_code,
                image_type_code: data.image_type_code,
                width: data.width,
                height: data.height,
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                order_number: data.order_number
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                banner_url: data.banner_url,
                geometry_type_code: data.geometry_type_code,
                geometry_type_title: resp.geometry_type_title,
                image_type_code: data.image_type_code,
                image_type_title: resp.image_type_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                width: data.width,
                height: data.height,
                is_deprecated: data.is_deprecated,
                is_all_country: data.is_all_country,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                title: data.title,
                countries_count: 0,
                order_number: data.order_number
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBannersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandBanner.exec({
                data: {
                    brands_aff_banner_id: data.key,
                    banner_url: data.banner_url,
                    geometry_type_code: data.geometry_type_code,
                    image_type_code: data.image_type_code,
                    width: data.width,
                    height: data.height,
                    is_deprecated: data.is_deprecated,
                    is_all_country: data.is_all_country,
                    title: data.title,
                    order_number: data.order_number
                }
            }, function (resp) {
                _tmp.banner_url = data.banner_url;
                _tmp.title = data.title;
                _tmp.geometry_type_code = data.geometry_type_code;
                _tmp.geometry_type_title = resp.geometry_type_title;
                _tmp.image_type_code = data.image_type_code;
                _tmp.image_type_title = resp.image_type_title;
                _tmp.width = data.width;
                _tmp.height = data.height;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.is_all_country = data.is_all_country;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.order_number = data.order_number;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBannersListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsBannersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandBanner.exec({ data: { brands_aff_banner_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBannersListCtl.prototype.doSetIsDeprecated = function (key, isDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandBannerIsDeprecated.exec({ data: { brands_aff_banner_id: key, is_deprecated: isDeprecated } }, function (resp) {
                _tmp.is_deprecated = isDeprecated;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBannersListCtl.prototype.doSetOrderNumber = function (key, OrderNumber, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBrandBannerPriority.exec({
                data: {
                    brand_partner_banner_id: key,
                    order_number: OrderNumber
                }
            }, function (resp) {
                _tmp.order_number = OrderNumber;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParBrandsBannersListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsBannersListCtl = ParBrandsBannersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_banners_list/ctl/ParBrandsBannersListCtl.ts
// module id = 951
// module chunks = 0